import script from "./BomLinksPopover.vue?vue&type=script&setup=true&lang=js"
export * from "./BomLinksPopover.vue?vue&type=script&setup=true&lang=js"

import "./BomLinksPopover.vue?vue&type=style&index=0&id=25007420&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25007420"]])

export default __exports__